import { useQuery } from '@tanstack/react-query';

const fetchMeals = async (searchTerm) => {
  const query = searchTerm?.trim() || '';
  const res = await fetch(
    `https://www.themealdb.com/api/json/v1/1/search.php?s=${encodeURIComponent(query)}`
  );

  if (!res.ok) {
    throw new Error('Failed to fetch meals');
  }

  const data = await res.json();
  return data.meals || [];
};

export const useMeals = (searchTerm) => {
  return useQuery({
    queryKey: ['meals', searchTerm],
    queryFn: () => fetchMeals(searchTerm),
    staleTime: 1000 * 60 * 5,
  });
};